module.exports = __webpack_public_path__ + "static/media/2.f22f330f.png";